<app-left-side-nav></app-left-side-nav>
<app-header></app-header>
<!-- page content area start -->
<div class="afterLoginPageContainer" translate="no">
    <div class="container px-0">
        <div class="mainContent"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollUpDistance]="1.5"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScrollDown()">
            <div class="catalog-header" [ngClass]="{'mobile-padd':!isAuthenticated}">
                <div class="top-bar">
                    <div class="wrapper">
                        <button class="back-btn" (click)="onClickBack()">
                            <i class="fa fa-arrow-left"></i>
                        </button>
                        <div class="title-section" *ngIf="paramsToFetchData.pavilion_code">
                            <div class="logo">
                                <img [src]="pavilionImgUrl" alt="{{ pavilionName }}" />
                            </div>
                            <div class="info">
                                <h2 class="title">{{ pavilionName }}</h2>
                                <p><span class="me-1">{{companiesCount}} {{ companiesCount <=1 ? 'Company' : 'Companies' }} </span> | <span class="ms-1">
                                    {{ productsCount }}  {{ productsCount <= 1 ? 'Product' : 'Products' }}</span></p>
                            </div>
                        </div>
                        <div class="title-section" *ngIf="paramsToFetchData.search && !paramsToFetchData.category && !paramsToFetchData.pavilion_code">
                            <div class="info">
                                <h2 class="title"> <span class="txt">Search results for:</span> "{{ searchText }}" </h2>
                               
                            </div>
                        </div>
                        <div class="title-section" *ngIf="paramsToFetchData.category">
                            <div class="logo">
                                <img [src]="categoryImgUrl" alt="{{ categoryName }}" />
                            </div>
                            <div class="info">
                                <h2 class="title">{{ categoryName }}</h2>
                                <p><span class="me-1">{{companiesCount}} {{ companiesCount <=1 ? 'Company' : 'Companies' }} </span> | <span class="ms-1">
                                    {{ productsCount }}  {{ productsCount <= 1 ? 'Product' : 'Products' }}</span></p>
                            </div>
                        </div>
                      

                    </div>
                    <div class="icons">
                        <i class="fa-regular fa-circle-check" (click)="openWishlist()" *ngIf="isAuthenticated"></i>
                        <i class="fa fa-search" id="searchIcon" (click)="openFloatingSearch()"></i>
                    </div>
                </div>

                <!-- Floating Search Bar -->
                <div class="floating-search" id="floatingSearch" [class.active]="isSearchOpen">
                    <div class="search-container">
                        <i class="fa fa-search" (click)="onSearchIconClick()"></i>
                        <input type="text" 
                        placeholder="Search..." 
                        id="searchInput" 
                        [(ngModel)]="searchText"
                        (ngModelChange)="onSearchInput()"
                        #searchInput 
                        />
                        <i class="fa fa-times" id="closeSearch" (click)="closeFloatingSearch()"></i>
                    </div>
                </div>
            </div>                       
            <div class="tab-content" *ngIf="isDataLoaded" [ngClass]="{'mobile-mt':!isAuthenticated}">
                <div class="my-4 px-3">
                    <button (click)="viewLayout()" class="view-layout-btn w-100">View Layout</button>
                </div> 

                <div class="title-section" *ngIf="paramsToFetchData.search 
                && (paramsToFetchData.category || paramsToFetchData.pavilion_code)">
                    <div class="info">
                        <h2 class="title"> <span class="txt">Search results for:</span> "{{ searchText }}" </h2>
                       
                    </div>
                </div>

                <div class="ads-outer">
                    <app-catalogue-ads [adsPavilionCode]="paramsToFetchData.pavilion_code ?? ''"></app-catalogue-ads>
                </div>

                <div class="product-list" *ngIf="productList && productList.length > 0; else noProductsTemplate">              
                    <div class="block" *ngFor="let product of productList">
                        <a (click)="viewProductDetails(product.encoded_product_id)">
                            <div class="card">
                                <div class="wrapper position-relative">
                                    <img class="card-img-top"
                                        [src]="product.media_type === 'image' ? product.media_url : product.bigthumb_url"
                                        onerror="this.src='/assets/images/gray-bg.png'"
                                        alt="{{ product.title_english }}">
                                    <span *ngIf="product.media_type === 'youtubevideo'" class="playicon">
                                        <i class="fa-brands fa-youtube"></i>
                                    </span>
                                </div>
                                <div class="card-body">
                                    <h6 class="product-name">{{ product.title_english }}</h6>
                                    <p class="company-name">{{ product.brandname }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="section-loader text-center mx-auto" *ngIf="isLoadingMore">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                 <div class="catlogWrapper px-3" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                    <img src="/assets/images/buy_your_ticket.png" alt="Go To Digital Catalogue" />
                 </div>
                <ng-template #noProductsTemplate>
                    <div class="no-data">
                        <p>No Records Found.</p>
                    </div>
                </ng-template>
            </div>

            <div class="tabs">
                <div class="tabs-inner">
                    <div class="tab-item active">
                        <img class="icon" src="/assets/images/product-icon.png" alt="product icon" />
                        <span>Products</span>
                    </div>
                    <div class="tab-item" (click)="routeTocompaniesList()">
                        <img class="icon" src="/assets/images/company-icon.png" alt="company icon" />
                        <span>Companies</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>